import React, { Fragment, useEffect } from 'react'
import { UiCol, UiRowContainer } from "../grid-container/GridContainer"
import MenuIcon from "../../../../styles/img/hamburger-menu-icon.png"
import CloseIcon from "../../../../styles/img/close-icon.png"
import PropTypes from 'prop-types';


export function UiTopNavBarWr(props) {

  return (
    <>
      <div className={props.isActive ? "sb-top-nav-wr__nav-bar expand" : "sb-top-nav-wr__nav-bar d-lg-block collapsed "}  >
        <ul>
          {props.children}
        </ul>
        <span onClick={props.close} className="sb-mobile-nav-close">
          <img src={CloseIcon} />
        </span>
      </div>

    </>
  )
}

export function UiTopNavItem(props) {

  let pathname = window.location.pathname;
  useEffect(() => {
    pathname = window.location.pathname;
  }, [window.location.pathname]);

  return (
    <>
      <li>

        {pathname && <>
          {pathname.match(`/${props.pathname}`) && <span className='sb-nav-bar-active-border'></span>}
          <a href={props.href} className={pathname.match(`/${props.pathname}`)
            ? 'active-link'
            : ''}>
            {props.label}
          </a>
          {pathname.match(`/${props.pathname}`) && <span className='sb-nav-bar-active-border'></span>} </>}

        {!pathname && <><span className='sb-nav-bar-active-border'></span>
          <a onClick={props.onClick} className='active-link'
          >
            {props.label}
          </a>
          <span className='sb-nav-bar-active-border'></span></>}

      </li>
    </>
  )
}

export const UiMobileNavBar = (props) => {
  return (

    <div className="sb-mobile-top-navbar d-lg-none ">
      <div className="sb-mobile-top-navbar__wrapper">
        <i className="sb-mobile-top-navbar__hamburger-icon" onClick={props.toggle}>
          <img src={MenuIcon} />
        </i>
        <div className='sb-mobile-top-navbar__separator'></div>
      </div>
    </div>

  )
}

export const UiHeaderLogo = (props) => {
  return (

    <div className="sb-top-nav-wr__logo">
      <img src={props.logo} alt="logo" />
    </div>

  )
}

export const UiLoginContainer = (props) => {
  return (
    <div className='sb-login-page-container'>
      <header>
        {props.children}
      </header>
    </div>
  )
}
export const UiLoginCustomContainer = (props) => {
  return (
    <div className='sb-login-page-custom-container'>
      <header>
        {props.children}
      </header>
    </div>
  )
}

export const UiLoginPageLogo = (props) => {
  return (
    <div className='sb-login-page-logo'>
      <img src={props.Logo} alt="logo" />
      {props.heading && 
        <h3>{props.heading}</h3>
      }
    </div>
  )
}

// export const UiLoginOptions = (props) => {
//   return (
//     <>
//       <a className='sb-login-link' onClick={props.signin}>Sign In</a>
//       <span>/</span>
//       <a className='sb-login-link' onClick={props.signup}> Sign Up </a>
//     </>
//   )
// }
export const UiLoginOptions = (props) => {
  return (
      <>
          {props.signin && (
              <a className="sb-login-link" onClick={props.signin}>
                  Sign In
              </a>
          )}

          {props.signin && props.signup && <span>/</span>}
          {props.signup && (
              <a className="sb-login-link" onClick={props.signup}>
                  {" "}
                  Sign Up{" "}
              </a>
          )}
      </>
  );
};

UiHeaderLogo.propTypes = {
  logo: PropTypes.string,
  pathname: PropTypes.string,
  toggle: PropTypes.func

};

